module.exports = __webpack_public_path__ + "img/globe.1f92f332.png";